import { render, staticRenderFns } from "./integralJL.vue?vue&type=template&id=12b68f13&scoped=true&"
import script from "./integralJL.vue?vue&type=script&lang=js&"
export * from "./integralJL.vue?vue&type=script&lang=js&"
import style0 from "./integralJL.vue?vue&type=style&index=0&id=12b68f13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b68f13",
  null
  
)

export default component.exports